// export for convenience.
export { ActivatedRoute } from '@angular/router';

import { ReplaySubject } from 'rxjs';
import { convertToParamMap, ParamMap, Params } from '@angular/router';
import { map } from 'rxjs/operators';

/**
 * An ActivateRoute test double with a `paramMap` observable.
 * Use the `setParamMap()` method to add the next `paramMap` value.
 */
export class ActivatedRouteStub {
  // Use a ReplaySubject to share previous values with subscribers
  // and pump new values into the `paramMap` observable
  private paramSubject = new ReplaySubject<ParamMap>();
  private queryParamSubject = new ReplaySubject<ParamMap>();
  private subject3 = new ReplaySubject<ParamMap>();
  private subject4 = new ReplaySubject<ParamMap>();
  snapshot: {
    paramMap: ParamMap;
    queryParamMap: ParamMap;
  } = {
    paramMap: convertToParamMap({}),
    queryParamMap: convertToParamMap({})
  };
  constructor(initialParams?: Params) {
    this.setParamMap(initialParams);
  }

  /** The mock paramMap observable */
  readonly paramMap = this.paramSubject.asObservable();
  readonly params = this.paramSubject.asObservable().pipe(
    map(m => {
      let params = {};
      m.keys.forEach(key => {
        params[key] = m.get(key);
      });
      return params;
    })
  );

  /** Set the paramMap observables's next value */
  setParamMap(params?: Params) {
    this.snapshot.paramMap = convertToParamMap(params);
    this.paramSubject.next(convertToParamMap(params));
  }

  /** The mock queryParamMap observable */
  readonly queryParamMap = this.queryParamSubject.asObservable();

  /** Set the queryParamMap observables's next value */
  setQueryParamMap(params?: Params) {
    this.snapshot.queryParamMap = convertToParamMap(params);
    this.queryParamSubject.next(convertToParamMap(params));
  }

  /** The mock fragmentMap observable */
  readonly fragment = this.subject3.asObservable();

  /** Set the queryParamMap observables's next value */
  setFragment(params?: Params) {
    this.subject3.next(convertToParamMap(params));
  }

  /** The mock fragmentMap observable */
  readonly data = this.subject4.asObservable();

  /** Set the queryParamMap observables's next value */
  setData(params?: Params) {
    this.subject4.next(convertToParamMap(params));
  }
}
